import { CommonModule } from '@angular/common';
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ChatService } from '../../../services/chat.service';

@Component({
  selector: 'app-alert-popup',
  templateUrl: './alert-popup.component.html',
  styleUrls: ['./alert-popup.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class AlertPopupComponent implements OnInit {
  @Input() title: string = '';
  @Input() message: string = '';
  @Output() onClose: EventEmitter<any> = new EventEmitter();

  ngOnInit() {}

  constructor(private chatService: ChatService) {}

  get configs() {
    return this.chatService.configs;
  }

  onCloseClick() {
    this.onClose.emit();
  }
}
